import { Entity } from '../../../../core/entity';
import type { IValue } from '@/engine/DataFlow/Graph';
import { Type } from '@/engine/DataFlow/Type';
import { action, computed } from 'mobx';
import type * as THREE from 'three';

interface SplineProps {
  basePts: Array<THREE.Vector3>;
}

export class SplineIndicationModel extends Entity<SplineProps> implements IValue {
  public static readonly Type: Type = new Type('SplineIndicationModel');

  public readonly type: Type = SplineIndicationModel.Type;

  @action
  public addPoint(point: THREE.Vector3): void {
    this.props.basePts = [...this.props.basePts, point];
  }

  @action
  public updateLastPoint(point: THREE.Vector3): void {
    this.props.basePts = [...this.props.basePts.slice(0, this.props.basePts.length - 1), point];
  }

  @computed
  public get basePts(): Array<THREE.Vector3> {
    return this.props.basePts;
  }
}
